import { Assort } from "./../../../models/Assort";
import { Exercise } from "./../../../models/Exercise";
import { useEffect, useState } from "react";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { GET_EVENTS, GET_TICKETS_EVENT } from "../../../api/apiRoutes";
import { setTicketAccessFromExercise, TicketAccess } from "../../../models/TicketAccess";

export default function useEvents() {
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const [exercise, setExercise] = useState<Exercise[]>([]);
  const [ticketAccess, setTicketAccess] = useState<TicketAccess>({} as TicketAccess);

  const [tickets, setTickets] = useState<Assort[]>([]);


const getEventExercises = async () => {

    const requestGetAssortGroups = async () => {
      const { result, isError } = await get(GET_EVENTS(facilityIds));
      if (!isError) {
        if (result.length > 0) {
          setExercise(result);      
        }
      }
    };
    requestGetAssortGroups();
  
}


  const formatTicketAccess = async (item:Exercise) => {
    let ticketAccessTransform = setTicketAccessFromExercise(
      item.objectId,
      item.name,
      item.startTime
    );
    setTicketAccess(ticketAccessTransform);

  }



  const getTicketsForEvent = async (objectId: number) => {
    const ids = `0,${objectId}`;
    const { result, isError } = await get(GET_TICKETS_EVENT(facilityIds, ids));
    if (!isError) {
      setTickets(result);
    }
  };

  return {
    getEventExercises,
    formatTicketAccess,
    getTicketsForEvent,
    exercise,
    tickets,
    ticketAccess,
  };
}
